import { PaymentMethodType } from '@app/domain/model/PaymentMethodType';
import { PaymentType } from '@app/domain/model/PaymentType';
import { boolean, InferType, number, object, string } from 'yup';

export const PaymentFrequencyStepSchema = object({
    paymentCount: number()
        .required('profile.validation.fieldRequired')
        .oneOf([1, 2, 4, 6, 12], 'eshop.general.validation.invalidPaymentCount'),
});

export const PaymentOptionsStepSchema = object({
    paymentType: string()
        .required('profile.validation.fieldRequired')
        .oneOf([PaymentType.Subscription, PaymentType.ManualPayment], 'eshop.general.validation.invalidPaymentType'),
});

export const PaymentMethodTypeStepSchema = object({
    paymentMethodType: string()
        .required('profile.validation.fieldRequired')
        .oneOf([PaymentMethodType.Card, PaymentMethodType.Banks], 'eshop.general.validation.invalidPaymentMethodType'),
    acceptCardAndPaymentProviderRules: boolean().when('paymentMethodType', {
        is: PaymentMethodType.Card,
        then: schema => schema.is([true], 'eshop.general.validation.mustAcceptPaymentProviderRules'),
        otherwise: schema => schema.optional(),
    }),
});

export const PaymentMethodStepSchema = object({
    paymentMethod: string()
        .min(1, 'eshop.general.validation.invalidPaymentMethod')
        .when('paymentMethodType', {
            is: 'banks',
            then: schema => schema.required('profile.validation.fieldRequired'),
        }),
});

export const CheckoutStepSchema = object()
    .concat(PaymentFrequencyStepSchema)
    .concat(PaymentOptionsStepSchema)
    .concat(PaymentMethodTypeStepSchema)
    .concat(PaymentMethodStepSchema);

export type CheckoutFormData = InferType<typeof CheckoutStepSchema>;

export interface CheckoutActionResult {
    formData: CheckoutFormData;
}
